<template lang="pug">
  div.ranges
    ul
      li(
        v-for="(item, index) in ranges"
        :key="index"
        :class="{ 'active': item.label === chosenLabel }"
        @click="selectPreset(item)"
      ) {{ item.label }}
</template>

<script>
import datefns from 'date-fns';
import defaultPresets from './presets';

const CUSTOM_RANGE_TEXT = 'Custom Range';

export default {
  props: {
    presets: {
      type: Array,
      default: () => defaultPresets
    },
    value: {
      type: Object,
      default: () => ({ })
    }
  },
  computed: {
    chosenLabel () {
      if (!this.value.start || !this.value.end) return '';
      const preset = this.presets.find(({ start, end }) => datefns.isSameDay(this.value.start, start) && datefns.isSameDay(this.value.end, end));
      return preset ? preset.label : !this.hideCustomRange ? CUSTOM_RANGE_TEXT : null;
    },
    ranges () {
      return [ ...this.presets, { label: CUSTOM_RANGE_TEXT } ];
    }
  },
  methods: {
    selectPreset (preset) {
      const { start, end } = preset;
      if (!start || !end) return;
      this.$emit('input', { start, end });
    }
  }
};
</script>

<style lang="scss" scoped>
.ranges {
  font-size: 12px;
  float: none;
  margin-top: 8px;
  text-align: left;

  ul {
    list-style: none;
    margin: 0 auto;
    padding: 0;
    width: 100%;
  }

  li {
    box-sizing: border-box;
    font-size: 12px;
    padding: 8px 12px;
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }

    &.active {
      color: #4285f4;
    }
  }
}

// Larger Screen Styling
@media (min-width: 564px) {
  .ranges  {
    ul {
      width: 140px;
    }
  }
}

.action-buttons {
  clear: both;
  padding: 8px;
  line-height: 12px;
  vertical-align: middle;
}
</style>

